<template>
    <div class="row" v-if="showRecentUserList">
        <div class="content-container">            
            <div class="rul">
                <div class="header">
                    <div class="title">Online Users</div>
                </div>
                <ul class="users">
                    <li v-for="member in onlineMembers" :key="member.userID">
                    <router-link :class="userClass({member})" :to="{ path: '/members/' + member.userID }">{{
                        member.displayName
                    }}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import api from "../../api/api";
    import enums from "../../store/models/user";

    export default {
        data() {
            return {
                onlineMembers: []
            }
        },
        methods: {
            userClass(user) {
                let cls = "memberDisplayGuest";
                switch (user.member.highestForumRoleID) {
                    case enums.roleEnum.MEMBER: cls = "memberDisplayMember"; break;
                    case enums.roleEnum.VIP: cls = "memberDisplayVIP"; break;
                    case enums.roleEnum.EDITOR: cls = "memberDisplayEditor"; break;
                    case enums.roleEnum.MODERATOR: cls = "memberDisplayModerator"; break;
                    case enums.roleEnum.FORUM_ADMINISRTATOR: cls = "memberDisplayForumAdmin"; break;
                    case enums.roleEnum.CORE_ADMINISRTATOR: cls = "memberDisplayCoreAdmin"; break;
                }
                // console.log(cls);
                return cls;
            }
        },
        computed: {
            showRecentUserList() {
                return true;
            }
        },
        mounted() {
            if (this.showRecentUserList) {
                api.get("/members/recentlyOnlineMembers").then((response) => {
                    this.onlineMembers = response.data;
                });
            }
        }
    }

</script>